import React, { useState } from "react";
import PropTypes from "prop-types";

import { Label, Input, Column, Field, Control } from "rbx";
import {
  SystemCodeSelect,
  CustomerNameSelect,
  CustomerNoSelect
} from "../inputs";

import FilterButtons from "../FilterButtons";

const INITIAL_FILTER_STATE = {};

function OrderFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const where = { ...inputs, [e.target.name]: value };
    if (e.target.name === "StatusRecIdRef") {
      where.StatusRecIdRef = parseInt(value);
    }
    if (e.target.name === "CustomerRecIdRef") {
      where.CustomerRecIdRef = parseInt(value);
    }
    if (e.target.name === "OrderNumber") {
      where.OrderNumber = parseInt(value);
    }
    setInputs({
      ...where
    });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Order #</Label>
              <Input
                name="OrderNumber"
                type="text"
                value={inputs.OrderNumber}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <CustomerNoSelect
                icon="user"
                label="Customer No."
                name="CustomerRecIdRef"
                value={inputs.CustomerRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <CustomerNameSelect
                icon="user"
                label="Customer Name"
                name="CustomerRecIdRef"
                value={inputs.CustomerRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <SystemCodeSelect
                icon="globe"
                label="Order Status"
                lookup={{ Category: "Order", Code: "OrderStatus" }}
                name="StatusRecIdRef"
                value={inputs.StatusRecIdRef}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
OrderFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default OrderFilters;
